import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import version from './version'
import user from './user'
import requests from './requests'
import realisation from './realisation'
import relations from './relations'
import chargingpoints from './chargingpoints'
import monitoring from './monitoring'
import tenant from './tenant'
import overlay from './overlay'
import files from './files.js'
import stakeholders from './stakeholders.js'
import synchronisation from './synchronisation.js'

import EVtables from './EVtables'

import debug from './debug'

/**
 *
 */
export default new Vuex.Store({
  state: {
    /**
     *
     */
    loaded: false,
  },

  getters: {
    loaded: state => state.loaded,
  },
  actions: {
  },
  mutations: {
    setLoadedState(state, { loaded }) {
      state.loaded = loaded
    },
  },

  modules: {
    chargingpoints,
    realisation,
    requests,
    relations,
    version,
    user,
    monitoring,
    tenant,
    overlay,
    debug,
    EVtables,
    files,
    stakeholders,
    synchronisation
  },
})
